import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

/**
 * News Letter Mail Routes and Pages
 */
const ListNewsLetterMailPage = React.lazy(() =>
  import("./ListNewsLetterMailPage")
);

const NewsLetterMailRoutes = () => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListNewsLetterMailPage />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};

export default NewsLetterMailRoutes;
